export default __webpack_public_path__ + "static/media/email.36ae2499.svg";